import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { FormControl, FormHelperText, InputBaseProps, InputLabel, OutlinedInput, OutlinedInputProps, SxProps, Typography } from '@mui/material';
import { ChangeEvent, KeyboardEvent } from 'react';
import TAGSvgIcon, { IconName } from '../TAGSvgIcon';
import { getInputStyles, getWrapperStyles, inputHelperTextStyles } from './TAGTextFieldInput.styles';
export interface ITextFieldInputProps extends InputBaseProps {
  endAdornment?: React.ReactNode | null;
  startAdornment?: React.ReactNode | null;
  fieldDisabled?: boolean;
  fieldError?: boolean;
  fieldHelperText?: string;
  fieldPlaceHolder?: string;
  fieldRequired?: boolean;
  iconName?: IconName;
  inputLabel?: string;
  inputSx?: SxProps;
  wrapperSx?: SxProps;
  value?: string;
  inputProps: OutlinedInputProps['inputProps'];
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}
export default function TAGTextFieldInput({
  color = 'primary',
  endAdornment = null,
  startAdornment = null,
  fieldDisabled = false,
  fieldError = false,
  fieldHelperText = '',
  fieldPlaceHolder = '',
  fieldRequired = true,
  iconName = undefined,
  inputLabel = '',
  inputSx = {},
  onChange,
  onKeyDown,
  wrapperSx = {},
  value = '',
  inputProps
}: Readonly<ITextFieldInputProps>) {
  let resolvedEndAdornment = endAdornment;
  if (iconName) {
    resolvedEndAdornment = fieldError ? <ErrorOutlineOutlinedIcon sx={{
      color: 'error.main'
    }} /> : <TAGSvgIcon icon={iconName} size={30} />;
  }
  return <FormControl fullWidth required={fieldRequired} sx={{
    ...getWrapperStyles(color, fieldError),
    ...wrapperSx
  }} data-sentry-element="FormControl" data-sentry-component="TAGTextFieldInput" data-sentry-source-file="TAGTextFieldInput.tsx">
			{inputLabel && <InputLabel data-testid="text_input_label">{inputLabel}</InputLabel>}

			<OutlinedInput value={value} placeholder={fieldPlaceHolder} sx={{
      ...getInputStyles(),
      ...inputSx
    }} disabled={fieldDisabled} error={fieldError} label={inputLabel} onChange={(e: ChangeEvent<HTMLInputElement>) => onChange?.(e)} onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => onKeyDown?.(e)} endAdornment={resolvedEndAdornment} startAdornment={startAdornment} inputProps={inputProps} data-sentry-element="OutlinedInput" data-sentry-source-file="TAGTextFieldInput.tsx" />

			{fieldHelperText && <FormHelperText error={fieldError} data-testid="text_input_helper_label" sx={inputHelperTextStyles}>
					<Typography variant="lowestLevelBook">{fieldHelperText}</Typography>
				</FormHelperText>}
		</FormControl>;
}